import React from "react";
export function FinalCTASection() {
  return <section className="section-card" data-id="element-43">
      <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-44">
        <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-45">
          Este puede ser tu Día 1.
        </h2>

        <p className="text-lg text-slate-100/80" data-id="element-46">
          El momento de reconectar con tu fe, de sentir paz interior y de volver
          a escuchar a Dios es ahora. No mañana. No &quot;cuando tenga tiempo&quot;.
          Ahora.
        </p>

        {/* ✅ BOTÓN QUE SUBE A LAS TARJETAS DE PRECIO */}
        <div className="pt-4" data-id="element-47">
          <a href="#pricing" className="inline-flex bg-gradient-to-r from-amber-400 to-amber-300 text-slate-900 font-semibold px-10 py-4 rounded-full shadow-lg hover:shadow-xl hover:translate-y-0.5 transition" data-id="element-48">
            QUIERO COMENZAR AHORA
          </a>
        </div>

        <p className="text-blue-300 text-sm mt-4" data-id="element-49">
          ✨ Acceso inmediato · 🎁 Bonos incluidos · 🛡️ Garantía de 7 días
        </p>

        <p className="text-slate-300 italic mt-8" data-id="element-50">
          &quot;La fe no se encuentra pensando en ella. Se encuentra viviéndola,
          un día a la vez.&quot;
        </p>
      </div>
    </section>;
}